export default "__VITE_ASSET__XmnSQkaN__"